// ======================================================================
// 📁 File: src/modules/service_crm/dashboard/pages/ServiceCRMDashboard.js
// 📝 Purpose:
//   Main dashboard page for Service CRM
//
//   Approved Dashboard Layout:
//
//   Row 1 - Filter Bar
//   Row 2 - KPI Cards
//   Row 3 - Ticket Status + SLA Performance
//
//   Future Phases:
//
//   Row 4 - Ticket Trend
//   Row 5 - Engineer Workload
//   Row 6 - Engineer Performance
//   Row 7 - Customer Experience
//   Row 8 - Ticket Aging
//   Row 9 - Pending Actions
//   Row 10 - Quick Actions
// ======================================================================

import React, {
  useState,
  useEffect,
} from "react";


import DashboardFilterBar
  from "../components/DashboardFilterBar";

import DashboardKPIBar
  from "../components/DashboardKPIBar";

import TicketStatusSection
  from "../components/TicketStatusSection";

import SLAPerformanceSection
  from "../components/SLAPerformanceSection";

import TicketTrendSection
  from "../components/TicketTrendSection";

import EngineerWorkloadSection
  from "../components/EngineerWorkloadSection";

import EngineerResolutionChart
  from "../components/EngineerResolutionChart";

import EngineerPerformanceGrid
  from "../components/EngineerPerformanceGrid";

import CustomerFeedbackChart
  from "../components/CustomerFeedbackChart";

import CustomerSatisfactionChart
  from "../components/CustomerSatisfactionChart";

import TicketAgingSection
  from "../components/TicketAgingSection";

import PendingFeedbackGrid
  from "../components/PendingFeedbackGrid";

import PendingSatisfactionGrid
  from "../components/PendingSatisfactionGrid";  

import QuickActionsSection
  from "../components/QuickActionsSection";

import DashboardDataDrawer
  from "../components/DashboardDataDrawer";

import dashboardService
  from "../services/dashboardService";

export default function ServiceCRMDashboard() {


  // ============================================================
  // FILTERS
  // ============================================================

  const [filters, setFilters] = useState({

    from_date: "",
    to_date: "",

    engineer: "",
    status: "",
    priority: "",
    customer: "",

  });
const [drawerOpen, setDrawerOpen] =
  useState(false);

const [drawerTitle, setDrawerTitle] =
  useState("");

const [drawerSubtitle, setDrawerSubtitle] =
  useState("");

const [drawerRows, setDrawerRows] =
  useState([]);

const [drawerColumns, setDrawerColumns] =
  useState([]);

const [summaryData, setSummaryData] =
  useState({

    total: 0,

    open: 0,

    assigned: 0,

    resolved: 0,

    closed: 0,

    escalated: 0,

  });

const [summaryLoading, setSummaryLoading] =
  useState(false);

const [statusData, setStatusData] =
  useState([]);

const [slaData, setSlaData] =
  useState([]);

const [trendData, setTrendData] =
  useState([]);

const [
  engineerWorkloadData,
  setEngineerWorkloadData
] = useState([]);
const [
  engineerPerformanceData,
  setEngineerPerformanceData
] = useState([]);

const [
  engineerResolutionData,
  setEngineerResolutionData
] = useState([]);

const [feedbackData, setFeedbackData] =
  useState([]);

const [
  satisfactionData,
  setSatisfactionData
] = useState([]);
const [agingData, setAgingData] =
  useState([]);

  const [
  pendingFeedbackData,
  setPendingFeedbackData
] = useState([]);

const [
  pendingSatisfactionData,
  setPendingSatisfactionData
] = useState([]);



  


  // ============================================================
  // TEMP KPI DATA
  // Replace with API later
  // ============================================================

  const kpis = {

  total:
    summaryData.total || 0,

  open:
    summaryData.open || 0,

  assigned:
    summaryData.assigned || 0,

  resolved:
    summaryData.resolved || 0,

  closed:
    summaryData.closed || 0,

  escalated:
    summaryData.escalated || 0,

};

  // ============================================================
  // TEMP STATUS DATA
  // Replace with API later
  // ============================================================

  

  // ============================================================
  // TEMP SLA DATA
  // Replace with API later
  // ============================================================

  
  










  // ============================================================
  // FILTER ACTIONS
  // ============================================================

  function handleApplyFilters() {

      loadSummary();
      loadStatusDistribution();
      loadSlaPerformance();
      loadTicketTrend();
      loadEngineerWorkload();
      loadEngineerPerformance();
      loadCustomerExperience();
      loadTicketAging();
      loadPendingActions();

    console.log(
      "Apply Filters",
      filters
    );
  }

  function handleResetFilters() {

    setFilters({

        from_date: "",
        to_date: "",

        engineer: "",
        status: "",
        priority: "",
        customer: "",

      });
      setTimeout(() => {

    loadSummary();
    loadStatusDistribution();
      loadSlaPerformance();
        loadTicketTrend();
        loadEngineerWorkload();
        loadEngineerPerformance();
        loadCustomerExperience();
        loadTicketAging();
        loadPendingActions();



  }, 0);
  }

  function handleRefresh() {

    console.log(
      "Refresh Dashboard"
    );
      loadSummary();
      loadStatusDistribution();
      loadSlaPerformance();
      loadTicketTrend();
      loadEngineerWorkload();
      loadEngineerPerformance();
      loadCustomerExperience();
      loadTicketAging();
      loadPendingActions();

  }

  // ============================================================
  // KPI CLICK
  // ============================================================

  function handleKpiClick(type) {

    console.log(
      "KPI Click:",
      type
    );

   // openDashboardDrawer(
   // type,
   // "KPI Drilldown"
  //);
  loadDrilldown(

    type,

    "KPI Drilldown",

    "status",

    type

  );

    // Future:
    // Open DashboardDataDrawer
  }

  // ============================================================
  // STATUS CLICK
  // ============================================================

  function handleStatusClick(status) {

    console.log(
      "Status Click:",
      status
    );
    loadDrilldown(

    status,

    "Status Drilldown",

    "status",

    status

  );

    // Future:
    // Open DashboardDataDrawer
  }

  // ============================================================
// SLA CLICK
// ============================================================

function handleSLAClick(category) {

  console.log(
    "SLA Click:",
    category
  );

  // Future:
  // Open DashboardDataDrawer
}

// ============================================================
// TREND CLICK
// ============================================================

function handleMonthClick(month) {

  console.log(
    "Month Click:",
    month
  );
}

// ============================================================
// ENGINEER CLICK
// ============================================================

function handleEngineerClick(engineer) {

  loadDrilldown(

    engineer,

    "Engineer Tickets",

    "engineer",

    engineer

  );
  console.log(
    "Engineer Click:",
    engineer
  );

  // Future:
  // Open DashboardDataDrawer
}

// ============================================================
// FEEDBACK CLICK
// ============================================================

function handleFeedbackClick(type) {

  console.log(
    "Feedback Click:",
    type
  );
}

// ============================================================
// SATISFACTION CLICK
// ============================================================

function handleSatisfactionClick(type) {

  console.log(
    "Satisfaction Click:",
    type
  );
}
function handleAgingClick(bucket) {

  loadDrilldown(

    bucket,

    "Ticket Aging",

    "aging",

    bucket

  );
  console.log(
    "Aging Click:",
    bucket
  );
}

function handleViewAllFeedback() {

  console.log(
    "View All Feedback"
  );
}

function handleViewAllSatisfaction() {

  console.log(
    "View All Satisfaction"
  );
}

function handleOpenFeedback(row) {

  console.log(
    "Open Feedback:",
    row
  );
}

function handleOpenSatisfaction(row) {

  console.log(
    "Open Satisfaction:",
    row
  );
}
function handleCreateTicket() {

  console.log(
    "Create Ticket"
  );
}

function handleTicketList() {

  console.log(
    "Ticket List"
  );
}

function handleVisits() {

  console.log(
    "Visits"
  );
}

function handleFeedback() {

  console.log(
    "Feedback"
  );
}

function handleSatisfaction() {

  console.log(
    "Satisfaction"
  );
}

function handleReports() {

  console.log(
    "Reports"
  );
}

async function loadSummary() {

  try {

    setSummaryLoading(true);

    const data =
      await dashboardService.getSummary(
        filters
      );

    setSummaryData(
      data || {}
    );

  } catch (error) {

    console.error(
      "Dashboard Summary Error",
      error
    );

  } finally {

    setSummaryLoading(false);

  }

}

async function loadStatusDistribution() {

  try {

    const data =
      await dashboardService
        .getStatusDistribution(
          filters
        );

    setStatusData(
      data || []
    );

  } catch (error) {

    console.error(
      "Status Distribution Error",
      error
    );

  }

}

async function loadSlaPerformance() {

  try {

    const data =
      await dashboardService
        .getSlaPerformance(
          filters
        );

    const formatted = [

      {
        category: "Within SLA",
        count:
          data?.within_sla || 0,
      },

      {
        category: "Near Breach",
        count:
          data?.near_breach || 0,
      },

      {
        category: "Breached",
        count:
          data?.breached || 0,
      },

    ];

    setSlaData(
      formatted
    );

  } catch (error) {

    console.error(
      "SLA Performance Error",
      error
    );

  }

}
async function loadTicketTrend() {

  try {

    const data =
      await dashboardService
        .getTicketTrend(
          filters
        );

    const formatted =
      (data || []).map(
        (row) => ({

          month:
            row.month,

          created:
            row.created || 0,

          closed:
            row.closed || 0,

        })
      );

    setTrendData(
      formatted
    );

  } catch (error) {

    console.error(
      "Ticket Trend Error",
      error
    );

  }

}
async function loadEngineerWorkload() {

  try {

    const data =
      await dashboardService
        .getEngineerWorkload(
          filters
        );

    setEngineerWorkloadData(
      data || []
    );

  } catch (error) {

    console.error(
      "Engineer Workload Error",
      error
    );

  }

}
async function loadEngineerPerformance() {

  try {

    const data =
      await dashboardService
        .getEngineerPerformance(
          filters
        );

    setEngineerPerformanceData(
      data || []
    );

    setEngineerResolutionData(

      (data || []).map(
        (row) => ({

          engineer:
            row.engineer,

          closed:
            row.closed || 0,

        })
      )

    );

  } catch (error) {

    console.error(
      "Engineer Performance Error",
      error
    );

  }

}

async function loadCustomerExperience() {

  try {

    const data =
      await dashboardService
        .getCustomerExperience(
          filters
        );

    setFeedbackData(
      data?.feedback || []
    );

    setSatisfactionData(
      data?.satisfaction || []
    );

  } catch (error) {

    console.error(
      "Customer Experience Error",
      error
    );

  }

}
async function loadTicketAging() {

  try {

    const data =
      await dashboardService
        .getTicketAging(
          filters
        );
    
    console.log(
      "AGING API RESPONSE",
      data
    );

    const formatted = [

  {
    bucket: "0-2 Days",
    count:
      data?.["0-2 Days"] || 0,
  },

  {
    bucket: "3-5 Days",
    count:
      data?.["3-5 Days"] || 0,
  },

  {
    bucket: "6-10 Days",
    count:
      data?.["6-10 Days"] || 0,
  },

  {
    bucket: "10+ Days",
    count:
      data?.["10+ Days"] || 0,
  },

];

setAgingData(
  formatted
);

  } catch (error) {

    console.error(
      "Ticket Aging Error",
      error
    );

  }

}
async function loadPendingActions() {

  try {

    const data =
      await dashboardService
        .getPendingActions(
          filters
        );

    setPendingFeedbackData(
      data?.pending_feedback || []
    );

    setPendingSatisfactionData(
      data?.pending_satisfaction || []
    );

  } catch (error) {

    console.error(
      "Pending Actions Error",
      error
    );

  }

}

async function loadDrilldown(
  title,
  subtitle,
  drillType,
  value
) {

  try {

    const rows =
      await dashboardService
        .getDashboardDrilldown({

          type: drillType,

          value: value,

          ...filters,

        });

    setDrawerTitle(
      title
    );

    setDrawerSubtitle(
      subtitle
    );

    setDrawerColumns([

      {
        key: "ticket_no",
        label: "Ticket No",
      },

      {
        key: "customer",
        label: "Customer",
      },

      {
        key: "status",
        label: "Status",
      },

    ]);

    setDrawerRows(
      rows || []
    );

    setDrawerOpen(true);

  } catch (error) {

    console.error(
      "Drilldown Error",
      error
    );

  }

}
function openDashboardDrawer(
  title,
  subtitle
) {

  setDrawerTitle(title);

  setDrawerSubtitle(
    subtitle
  );

  setDrawerColumns([
    {
      key: "ticket_no",
      label: "Ticket No",
    },
    {
      key: "customer",
      label: "Customer",
    },
    {
      key: "status",
      label: "Status",
    },
  ]);

  setDrawerRows([
    {
      ticket_no: "SR-1001",
      customer: "ABC Industries",
      status: "OPEN",
    },
    {
      ticket_no: "SR-1002",
      customer: "XYZ Manufacturing",
      status: "ASSIGNED",
    },
  ]);

  setDrawerOpen(true);
}

  useEffect(() => {

  loadSummary();
  loadStatusDistribution();
    loadSlaPerformance();
    loadTicketTrend();
     loadEngineerWorkload();
      loadEngineerPerformance();
       loadCustomerExperience();
       loadTicketAging();
       loadPendingActions();







}, []);

  // ============================================================
  // RENDER
  // ============================================================

  return (

    <div>

      {/* ====================================================== */}
      {/* PAGE HEADER */}
      {/* ====================================================== */}

      <div
        style={{
          background:
            "linear-gradient(90deg, #0f172a, #1e40af)",

          borderRadius: 14,

          padding: "18px 24px",

          color: "#fff",

          display: "flex",

          justifyContent: "space-between",

          alignItems: "center",

          marginBottom: 20,
        }}
      >

        <div>

          <div
            style={{
              fontSize: 22,
              fontWeight: 700,
            }}
          >
            Service CRM Dashboard
          </div>

          <div
            style={{
              fontSize: 13,
              opacity: 0.9,
            }}
          >
            Monitor service operations,
            tickets and customer experience
          </div>

        </div>

      </div>

      {/* ====================================================== */}
      {/* ROW 1 - FILTER BAR */}
      {/* ====================================================== */}

      <DashboardFilterBar

        filters={filters}

        setFilters={setFilters}

        engineers={[]}

        customers={[]}

        onApply={
          handleApplyFilters
        }

        onReset={
          handleResetFilters
        }

        onRefresh={
          handleRefresh
        }

      />

      {/* ====================================================== */}
      {/* ROW 2 - KPI CARDS */}
      {/* ====================================================== */}

      <DashboardKPIBar

        kpis={kpis}

        onKpiClick={
          handleKpiClick
        }

      />

      {/* ====================================================== */}
      {/* ROW 3 */}
      {/* TICKET STATUS + SLA */}
      {/* ====================================================== */}

      <div className="row g-3">

        {/* STATUS */}

        <div className="col-lg-6">

          <TicketStatusSection

            data={statusData}

            onStatusClick={
              handleStatusClick
            }

          />

        </div>

        {/* SLA */}

        <div className="col-lg-6">

          <SLAPerformanceSection

            data={slaData}

            onBarClick={
              handleSLAClick
            }

          />

        </div>

      </div>
            {/* ====================================================== */}
      {/* ROW 4 - TICKET TREND */}
      {/* ====================================================== */}

      <div className="mt-3">

        <TicketTrendSection
          data={trendData}
          onMonthClick={handleMonthClick}
        />

      </div>

      {/* ====================================================== */}
      {/* ROW 5 - ENGINEER WORKLOAD */}
      {/* ====================================================== */}

      <div className="mt-3">

        <EngineerWorkloadSection
          data={engineerWorkloadData}
          onEngineerClick={handleEngineerClick}
        />

      </div>

      {/* ====================================================== */}
      {/* ROW 6 - ENGINEER PERFORMANCE */}
      {/* ====================================================== */}

      <div className="row g-3 mt-1">

        <div className="col-lg-6">

          <EngineerResolutionChart
            data={engineerResolutionData}
            onEngineerClick={handleEngineerClick}
          />

        </div>

        <div className="col-lg-6">

          <EngineerPerformanceGrid
            data={engineerPerformanceData}
            onEngineerClick={handleEngineerClick}
          />

        </div>

      </div>

      {/* ====================================================== */}
      {/* ROW 7 - CUSTOMER EXPERIENCE */}
      {/* ====================================================== */}

      <div className="row g-3 mt-3">

        <div className="col-lg-6">

          <CustomerFeedbackChart
            data={feedbackData}
            onFeedbackClick={handleFeedbackClick}
          />

        </div>

        <div className="col-lg-6">

          <CustomerSatisfactionChart
            data={satisfactionData}
            onSatisfactionClick={handleSatisfactionClick}
          />

        </div>
        

      </div>
{/* ====================================================== */}
{/* ROW 8 - TICKET AGING */}
{/* ====================================================== */}

<div className="mt-3">

  <TicketAgingSection

    data={agingData}

    onBucketClick={
      handleAgingClick
    }

  />

</div>

{/* ====================================================== */}
{/* ROW 9 - PENDING ACTIONS */}
{/* ====================================================== */}

<div className="row g-3 mt-1">

  <div className="col-lg-6">

    <PendingFeedbackGrid
      data={pendingFeedbackData}
      onViewAll={handleViewAllFeedback}
      onOpen={handleOpenFeedback}
    />

  </div>

  <div className="col-lg-6">

    <PendingSatisfactionGrid
      data={pendingSatisfactionData}
      onViewAll={handleViewAllSatisfaction}
      onOpen={handleOpenSatisfaction}
    />

  </div>

</div>

{/* ====================================================== */}
{/* ROW 10 - QUICK ACTIONS */}
{/* ====================================================== */}

<div className="mt-3">

  <QuickActionsSection

    onCreateTicket={handleCreateTicket}

    onTicketList={handleTicketList}

    onVisits={handleVisits}

    onFeedback={handleFeedback}

    onSatisfaction={handleSatisfaction}

    onReports={handleReports}

  />

</div>
<DashboardDataDrawer

  open={drawerOpen}

  title={drawerTitle}

  subtitle={drawerSubtitle}

  rows={drawerRows}

  columns={drawerColumns}

  onClose={() =>
    setDrawerOpen(false)
  }

/>

</div>

);

}